/** @format */
import { actionDebug } from '../../core/debug';

export type platformGroupsType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const platformGroupsConstants = {
    LIST: 'platform_group_list',
    ITEM: 'platform_group_item',
    EDIT: 'platform_group_edit',
    DELETE: 'platform_group_delete',
    MANAGE: 'platform_group_manage',
    ADD: 'platform_group_add',
};

export function platformUserDefinedRolesReducers(state = {}, action: platformGroupsType): object {
    actionDebug('platformUserDefinedRoles reducer: ' + action.type);
    switch (action.type) {
        case platformUserDefinedRolesConstants.LIST:
            return {
                type: action.type,
                collections: action.collections,
            };
        default:
            return { ...state };
    }
}

export type platformUserDefinedRolesType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const platformUserDefinedRolesConstants = {
    LIST: 'platform_user_defined_roles_list',
    ITEM: 'platform_user_defined_roles_item',
    EDIT: 'platform_user_defined_roles_edit',
    DELETE: 'platform_user_defined_roles_delete',
    MANAGE: 'platform_user_defined_roles_manage',
    ADD: 'platform_user_defined_roles_add',
};

export function platformGroupsReducers(state = {}, action: platformGroupsType): object {
    actionDebug('Platform Groups reducer: ' + action.type);
    switch (action.type) {
        case platformGroupsConstants.LIST:
            return {
                type: action.type,
                collections: action.collections,
            };
        default:
            return { ...state };
    }
}

export type platformUserDefinedRolesToGroupsType = {
    type?: string;
    collections?: any;
    item?: any;
    processSuccess?: boolean;
    success?: boolean;
    data?: any;
    deletedSuccess?: boolean;
    message?: string;
};

export const platformUserDefinedRolesToGroupsConstants = {
    LIST: 'platform_user_defined_roles_to_groups_list',
    ITEM: 'platform_user_defined_roles_to_groups_item',
    EDIT: 'platform_user_defined_roles_to_groups_edit',
    DELETE: 'platform_user_defined_roles_to_groups_delete',
    MANAGE: 'platform_user_defined_roles_to_groups_manage',
    ADD: 'platform_user_defined_roles_to_groups_add',
};

export function platformUserDefinedRolesToGroupsReducers(state = {}, action: platformUserDefinedRolesToGroupsType): object {
    actionDebug('Platform Groups reducer: ' + action.type);
    switch (action.type) {
        case platformUserDefinedRolesToGroupsConstants.LIST:
            return {
                type: action.type,
                collections: action.collections,
            };
        default:
            return { ...state };
    }
}

export type rolesCredentialType = {
    type?: string;
    collections?: any;
};

export const rolesCredentialConstants = {
    LIST: 'roles_credential_list',
};

export function rolesCredentialReducers(state = {}, action: rolesCredentialType): object {
    actionDebug('Roles credential reducer: ' + action.type);
    switch (action.type) {
        case rolesCredentialConstants.LIST:
            return {
                type: action.type,
                collections: action.collections,
            };
        default:
            return { ...state };
    }
}
